
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/errors/transactions",
      function () {
        return require("private-next-pages/docs/errors/transactions.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/errors/transactions"])
      });
    }
  